import { isArray } from "lodash";
import { CommonStatusType } from "src/app/globals/custom-types/global-custom-types";
import SystemConstants from "src/app/util/constants/SystemConstants";
import { CoordinateTypeLocation } from "../../../interface/input-location/i-input-location-loc-type";

export interface Locale {
  localeName: string;
  localepath?: string;
  contactName: string;
  phoneNumber: number;
  localeType: string | "Community";
  localePasscode: number | string;
  email: string;
  address: IAddress
  numberOfPeople: number;
  isSendEmail: boolean | number;
  status: CommonStatusType;
  basePath: string;
  _id?: string;
  parentId: string;
  child: Locale[];
  ownerId: string;
  level: number;
  parentIds: string[];
  slug: string;
}

export interface IAddress {
  city: string;
  country: string;
  formattedAddress: string;
  loc: CoordinateTypeLocation
  postalCode: string
  state: string
}

export class AllLocaleWithChild {
  all: boolean;
  children? : string[];

  getLocaleIdsInArray(allLocaleValue = SystemConstants.ALL) {
      if(this.all) {
        return [allLocaleValue];
      } else {
        return this.children
      }
  }

  constructor(options? : { localeId?: string  | typeof SystemConstants.ALL | string[] | string, all?: boolean, 
    children?: string[] 
  existingValue?: AllLocaleWithChild, allLocaleValue?: string, }) {
    let allLocaleValue = options && options.allLocaleValue || SystemConstants.ALL
    if(options && options.localeId) {
      if((options.localeId === allLocaleValue) || options.localeId.includes(allLocaleValue)) {      
        this.all = true;
        this.children = [allLocaleValue]
      } else {
          this.all = false;
          if(options.localeId && isArray(options.localeId) && options.localeId.length > 0)
            this.children = options.localeId
          if(typeof options.localeId === "string" )
            this.children = [options.localeId];
      }
      return this;
    } else if (options && (options.existingValue) ) {
      this.all = options.existingValue.all;
      this.children = options.existingValue.children;
    } else {
      this.all = false;
      this.children= [];
    }
  }
}

export interface ILocale extends Partial<Locale> {
  searchText?: string;
}

export type LocaleType = AllLocaleWithChild | typeof SystemConstants.ALL | string | string[] | Partial<Locale>[] | Partial<Locale>;